import React, { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Col, Container, Row, Form, FormGroup, Label, Button, Spinner } from 'reactstrap'
import useAddIdentiMarket from './useAddIdentiMarket'
import useUpdateIdenMarket from './useUpdateIdenMarket'
import useRelativeMarketList from './useRelativeMarketList'

const IdentiAndMarketAreaAddForm = ({onClose,orderId,id}) => {
    console.log("orderid",orderId)
    console.log("id",id)

    // const subjectData = subjData?.subject || '';
    // const marketData = subjData?.market || '';
    
    // custom hook to get the identification and market data
    const{isPending, isSuccess, isError, error, fetchedData,refetch}= useRelativeMarketList(orderId,id)

    const subjectData = fetchedData?.subject || '';
    const marketData = fetchedData?.market || '';

    // custom hook for add indentification and market
    const{isAdding, isAdded, addIdenMarket}=useAddIdentiMarket();
    // custom hook for update indetification and market
    const{isEditing, isEdited, updateIdenMarket} = useUpdateIdenMarket();

    const{register,handleSubmit,setValue,formState:{errors},reset} = useForm({
        defaultValues:{
            censusTract:"",
            legalDesc:"",
            propType:"",
            interestAppraised:"",
            marketAreaName:"",
            marketTrend:"",
            tmprFVal:"",
            tmprTo:"",
            tmprPredom:"",
            tmarFVal:"",
            tmarTo:"",
            tmarPredom:""
        },
        criteriaMode:"all",
        mode:"onChange"
    })
    // render the data if found
    useEffect(()=>{
        if(fetchedData){
            const formValues={
                censusTract: subjectData?.census_tract || "",
                legalDesc: subjectData?.legal_desc || "",
                propType: subjectData?.property_type || "",
                interestAppraised: subjectData?.interest_appraised || "",
                marketAreaName: subjectData?.market_area_name || "",

                marketTrend: marketData?.market_val_trend || "",
                tmprFVal: marketData?.tmpr_from || "",
                tmprTo: marketData?.tmpr_to || "",
                tmprPredom: marketData?.tmpr_predom || "",
                tmarFVal: marketData?.tmar_from || "",
                tmarTo: marketData?.tmar_to || "",
                tmarPredom: marketData?.tmar_predom || ""
            };
            reset(formValues);
        }else{
            reset();
        }
    },[fetchedData])

    const onSubmit=(data)=>{
        const payload = {
            subject: {
            census_tract: data.censusTract,
            interest_appraised: data.interestAppraised,
            legal_desc: data.legalDesc,
            market_area_name: data.marketAreaName,
            property_type: data.propType
            },
            market: {
            market_val_trend: data.marketTrend,
            tmar_from: data.tmarFVal,
            tmar_predom: data.tmarPredom,
            tmar_to: data.tmarTo,
            tmpr_from: data.tmprFVal,
            tmpr_predom: data.tmprPredom,
            tmpr_to: data.tmprTo
            }
        };

        if(fetchedData){
            updateIdenMarket({...payload,orderId:orderId,id:subjectData.id},{
                onSuccess:()=>{
                    onClose();
                }
            })
        }else{
            const newPayload = {
                payload,
                orderId: orderId,
                id:subjectData.id
            }
            addIdenMarket(newPayload,{
                onSuccess:()=>{
                    onClose();
                }
            })
        }
        
    }
    if(isPending){
        return (
            <Container fluid className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                <Spinner />
            </Container>
        );
    }

  return (
    <Container fluid>
        <Row>
            <Col>
                <Form onSubmit={handleSubmit(onSubmit)}>

                    <div className='mb-4 border-bottom pb-2'>
                            <h5 className='fw-bold'>Subject Property Details</h5>
                    </div>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='censusTract' className='form-label'>Census Tract</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='censusTract'
                                        name='censusTract'
                                        placeholder='Census Tract'
                                        {...register("censusTract", {required:"Census Tract required"})}
                                    />
                                    {errors.censusTract && <span className="text-danger">{errors.censusTract.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='legalDesc' className='form-label'>Legal Description</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='legalDesc'
                                        name='legalDesc'
                                        placeholder='Legal Description'
                                        {...register("legalDesc", {required:"Legal Description required"})}
                                    />
                                    {errors.legalDesc && <span className="text-danger">{errors.legalDesc.message}</span>}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label htmlFor='propType' className='form-label'>Property Type</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='propType'
                                        name='propType'
                                        placeholder='Property Type'
                                        {...register("propType", {required:"Property Type required"})}
                                    />
                                    {errors.propType && <span className="text-danger">{errors.propType.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='interestAppraised' className='form-label'>Interest Appraised</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='interestAppraised'
                                        name='interestAppraised'
                                        placeholder='Interest Appraised'
                                        {...register("interestAppraised", {required:"Interest Appraised required"})}
                                    />
                                    {errors.interestAppraised && <span className="text-danger">{errors.interestAppraised.message}</span>}
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className='mb-4 border-bottom pb-2'>
                        <h5 className='fw-bold'>Market Analysis</h5>
                    </div>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='marketAreaName' className='form-label'>Market Area Name</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='marketAreaName'
                                        name='marketAreaName'
                                        placeholder='Market Area Name'
                                        {...register("marketAreaName",{required: "Market Area Name is Required"})}
                                    />
                                {errors.marketAreaName && <span className="text-danger">{errors.marketAreaName.message}</span>}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label htmlFor='marketTrend' className='form-label'>Market Value Trend</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='marketTrend'
                                        name='marketTrend'
                                        placeholder='Market Value Trend'
                                    {...register("marketTrend",{required: "Market Value Trend is Required"})}
                                />
                                {errors.marketTrend && <span className="text-danger">{errors.marketTrend.message}</span>}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup>
                                <Label htmlFor='tmprFVal' className='form-label'>Typical Market Price Range-First Value</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='tmprFVal'
                                        name='tmprFVal'
                                        placeholder='Typical Market Price Range - First Value'
                                        {...register("tmprFVal",{required: "Typical Market Price Range is Required"})}
                                    />
                                    {errors.tmprFVal && <span className="text-danger">{errors.tmprFVal.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='tmprTo' className='form-label'>Typical Market Price Range - To</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='tmprTo'
                                        name='tmprTo'
                                        placeholder='Typical Market Price Range - To'
                                        {...register("tmprTo",{required: "Typical Market Price Range is Required"})}
                                    />
                                    {errors.tmprTo && <span className="text-danger">{errors.tmprTo.message}</span>}
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='tmprPredom' className='form-label'>TMPR Predominant</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='tmprPredom'
                                        name='tmprPredom'
                                        placeholder='TMPR Predominant'
                                        {...register("tmprPredom",{required: "TMPR Predominant is Required"})}
                                        />
                                    {errors.tmprPredom && <span className="text-danger">{errors.tmprPredom.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='tmarFVal' className='form-label'>Typical Market Age Range-First Value</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='tmarFVal'
                                        name='tmarFVal'
                                        placeholder='Typical Market Age Range - First Value'
                                        {...register("tmarFVal",{required: "Typical Market Age Range is Required"})}
                                    />
                                    {errors.tmarFVal && <span className="text-danger">{errors.tmarFVal.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='tmarTo' className='form-label'>Typical Market Age Range-To</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='tmarTo'
                                        name='tmarTo'
                                        placeholder='Typical Market Age Range-To - To'
                                        {...register("tmarTo",{required: "Typical Market Age Range-To is Required"})}
                                    />
                                    {errors.tmarTo && <span className="text-danger">{errors.tmarTo.message}</span>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label htmlFor='tmarPredom' className='form-label'>TMAR Predominant</Label>
                                    <input
                                        type='text'
                                        className='form-control border-primary-subtle'
                                        id='tmarPredom'
                                        name='tmarPredom'
                                        placeholder='TMAR Predominant'
                                        {...register("tmarPredom",{required: "TMAR Predominant is Required"})}
                                    />
                                    {errors.tmarPredom && <span className="text-danger">{errors.tmarPredom.message}</span>}
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row className='mt-2'>
                        <div style={{display:"flex", flexDirection:"row", alignItems:"center", justifyContent:"center"}}>
                            <Button type='submit' className="btn py-2" style={{ backgroundColor: "#00ADF0", color: "white", minWidth: "150px", fontWeight: "bolder" }} onClick={()=>refetch}>Save</Button>
                        </div>
                    </Row>
                </Form>
            </Col>
        </Row>
    </Container>
  )
}

export default IdentiAndMarketAreaAddForm